const minute = 1000 * 60;

export const staleTimes = {
  short: minute * 5,
  medium: minute * 10,
  long: minute * 20,
};
